// composables/useJob.ts

import SearchService from "@/api/SearchService";

export const useSearch = () => {
  const { searchProductApi } = SearchService();

  const searchProduct = async (
    page: number,
    limit: number,
    keyword: string
  ) => {
    const response = await searchProductApi(page, limit, keyword);
    return response?.data;
  };

  return {
    searchProduct
  };
};
